export default __webpack_public_path__ + "static/media/Banner_1024x500_Laptop.2b9404d4.png";